"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactVirtualized = require("react-virtualized");
var _reactSelect = require("react-select");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var _default = props => {
  const {
    children: rows,
    currentIndex,
    loadMoreOptions,
    moreOptionsAvailable,
    isFetchingData,
    setIsFetchingData,
    debouncedSearchedText
  } = props;
  const rowRenderer = ({
    key,
    index,
    style
  }) => /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    style: style,
    children: rows[index]
  }, key);
  const rowCount = rows.length;
  const onRowsRendered = (rowCount, {
    startIndex,
    stopIndex
  }) => {
    currentIndex.current = startIndex;
    if (loadMoreOptions && moreOptionsAvailable && !isFetchingData && stopIndex + 1 === rowCount) {
      setIsFetchingData(true);
      loadMoreOptions(debouncedSearchedText.current);
    }
  };
  if (rowCount) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactVirtualized.AutoSizer, {
      disableHeight: true,
      children: ({
        width
      }) => /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactVirtualized.List, {
        onRowsRendered: status => onRowsRendered(rowCount, status),
        width: width,
        height: Math.min(rowCount * 50, 200),
        rowCount: rowCount,
        scrollToIndex: currentIndex.current,
        rowHeight: 50,
        rowRenderer: rowRenderer
      })
    });
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactSelect.components.MenuList, {
    ...props
  });
};
exports.default = _default;